import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import BaseCheckboxComponent from '../shared-components/BaseCheckboxComponent';
import { getFiscalYearFromCheckboxForConfigReport, getIsReportValidForFiscalYearCheckbox, updateConfigReportFiscalYearForCheckbox } from './utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const FiscalYearHelpMessage = () => {
  const helpContent = /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "report-customization-components.customization-components.fiscal-year-checkbox.fiscal-year-help_jsx",
    options: {
      external: true,
      href: `/settings/${PortalIdParser.get()}/account-defaults/general`
    },
    elements: {
      Link
    }
  });
  return /*#__PURE__*/_jsx(HelpIcon, {
    title: helpContent,
    tooltipPlacement: "right"
  });
};
const CheckboxMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "report-customization-components.customization-components.fiscal-year-checkbox.useFiscalYearInAggregationLabel"
});
const ConfigReportFiscalReportCheckbox = BaseCheckboxComponent({
  reportGetter: getFiscalYearFromCheckboxForConfigReport,
  reportSetter: updateConfigReportFiscalYearForCheckbox,
  getIsReportValidForCheckbox: getIsReportValidForFiscalYearCheckbox,
  description: /*#__PURE__*/_jsx(FiscalYearHelpMessage, {}),
  descriptionLayout: 'horizontal',
  children: /*#__PURE__*/_jsx(CheckboxMessage, {})
});
export default ConfigReportFiscalReportCheckbox;